import React, { Component } from "react";
import {
  NewsFreedsDescriptionInfoContainer,
  NewsFreedsInfoContainer,
  NewsDescriptionLabel
} from "./NewsFreedsInfo.styled";
import { uploadFile } from "@s/api/file";
import { connectStore } from "redux-box";
import { module as newsFreeds } from "store/newsFreeds";
import { module as level } from "store/level";
import { ActivityUploadImageContainer } from "@c/activity-view/activity-pack-creator/activity-pack-info/ActivityPackInfo.styled";
import {
  ActivityUploadImageButton,
  ChangeImageButton,
  ImageContainer,
  SelectFileIn
} from "@c/activity-view/activity-creation-form/ActivityCreationForm.styled";
import { ImageLoader } from "static/styled/custom.styled";
import moment from "moment";
import {
  StorySectionLabelsContainer,
  StoryInputField
} from "@c/story-view/story-creator/story-info/StoryInfo.styled";
import {
  CheckBall,
  CheckBallInner,
  Chevron,
  DropDown,
  DropdownItem,
  DropDownMenu,
  FlexBetween,
  ThemeButton,
  FlexStart,
  SubLevelItem,
  DateSelectionField,
  ModalCountItem,
  ModalCountOverlayContainer
} from "static/styled/custom.styled";
import { ActivityDescription } from "static/styled/ActivityModal.styled";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import swal from "sweetalert2";
import "../../../../global.css";
import { module as onboard } from "@st/onboard";
import Permission from "@s/permission";

const errorHandler = err => {
  swal({
    text: err,
    type: "warning"
  });
};


class NewsFreedsInfo extends Component {
  constructor(props) {
    super();
    this.state = {
      noError: false,
      selectedLevels: [],
      levelData: [],
      unsetData: false,
      subLevelSelector: false,
      activeLevel: "",
      dateErr: "",
      selectedDate: moment(),
      imageChange: false,
      enableLoad: false,
      levelTypeSelector: false,
      news_info: {
        image: "",
        date: "",
        name: "",
        grade_level: [],
        source: "",
        newsEdit: false
      }
    };
  }

  componentDidMount() {
    let currentPath = window.location.href;
    if (currentPath.includes("/create")) {
      this.setState({
        newsEdit: true
      });
    }

    let levelList = this.props.level.levels.map((level) => {
      let levelData = {
        name: level,
        selected: false,
        clicked: false,
        levels: level !== 'Level 16' ? [
          { name: "Easy", selected: false },
          { name: "Hard", selected: false },
        ] : [
          { name: "Easy", selected: false },
          { name: "Medium", selected: false },
          { name: "Hard", selected: false },
        ],
      };
      return levelData;
    });
    this.setState({
      levelData: [
        {
          name: "Select All",
          selected: false,
          clicked: false,
          levels: [],
        },
        ...levelList,
      ],
    });

    let newsInfo = this.props.newsInfo;
    if (newsInfo !== null) {
      let date = newsInfo.date;
      let dateData = date.split("-");
      let newDate = moment();
      let currentDate = new Date();
      newDate.set({
        year: dateData[0],
        month: dateData[1] - 1,
        date: dateData[2]
      });
      let disableDate = new Date(newDate._d) >= currentDate;

      this.setState({
        selectedDate: newDate,
        selectedLevels: newsInfo.grade_level.sort(),
        disableDate: disableDate,
        news_info: {
          image: newsInfo.image,
          date: newsInfo.date,
          name: newsInfo.name,
          source: newsInfo.source
        }
      });
    }
  }

  componentWillUnmount() {
    this.unsetData();
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.newsFreeds && nextProps.newsFreeds.active_news_freed) {
      this.normalizeForState(nextProps.newsFreeds.active_news_freed);
    }
  };

  unsetData = () => {
    this.setState({
      selectedLevels: [],
      levelData: [],
      unsetData: false,
      activeLevel: "",
      disableDate: false,
      selectedDate: moment(),
      news_info: {
        image: "",
        date: "",
        name: "",
        grade_level: [],
        source: "",
        newsEdit: false
      }
    });
  };

  normalizeForState = activeNewsFreed => {
    let date = activeNewsFreed.date;
    let dateData = date.split("-");

    let newDate = moment();
    let currentDate = new Date();
    newDate.set({
      year: dateData[0],
      month: dateData[1] - 1,
      date: dateData[2]
    });
    let disableDate = new Date(newDate._d) >= currentDate;
    this.setState({
      selectedDate: newDate,
      selectedLevels: activeNewsFreed.grade_level,
      disableDate: disableDate,
      news_info: {
        image: activeNewsFreed.image,
        date: date,
        name: activeNewsFreed.name,
        source: activeNewsFreed.source
      }
    });
  };

  handleNameChange = evt => {
    this.setState({
      news_info: {
        ...this.state.news_info,
        name: evt.target.value
      }
    });
  };

  handleDescriptionChange = evt => {
    this.setState({
      news_info: {
        ...this.state.news_info,
        description: evt.target.value
      }
    });
  };

  handleSourceChange = evt => {
    this.setState({
      news_info: {
        ...this.state.news_info,
        source: evt.target.value
      }
    });
  };

  handleImageChange = e => {
    let reader = new FileReader();
    let file = e.target.files[0];
    let fileSize = e.target.files[0].size / 1024 / 1024;
    if (fileSize > 2) {
      swal("Oops!", "File size greater than 2MB ", "warning");
    } else {
      reader.onloadend = () => {
        this.setState({
          enableLoad: true,
          imageChange: false,
          news_info: { ...this.state.news_info, image: reader.result }
        });
      };
      reader.readAsDataURL(file);
      uploadFile(file).then(res => {
        this.setState({
          news_info: { ...this.state.news_info, image: res.file },
          enableLoad: false
        });
      });
    }
  };

  handleImageFocus = actionType => {
    if (actionType === "over" && this.state.imageChange === false)
      this.setState({
        imageChange: true
      });
    else if (actionType === "out" && this.state.imageChange === true)
      this.setState({
        imageChange: false
      });
  };

  setLevelData = () => {
    if (this.state.selectedLevels.length >= 25)
      this.handleLevelChange("Select All");
    else {
      let newLevelData = this.state.levelData;
      this.state.selectedLevels.forEach(selectedLevel => {
        let levelSliced = selectedLevel.split(":");
        newLevelData = newLevelData.map(level => {
          if (level.name === levelSliced[0]) {
            let subLevels =
              level.levels &&
              level.levels.map(subLevel => {
                if (subLevel.name === levelSliced[1])
                  return { ...subLevel, selected: true };
                return subLevel;
              });
            return { ...level, selected: true, levels: subLevels };
          }
          return { ...level };
        });
      });

      this.setState({
        levelData: newLevelData
      });
    }
  };

  handleLevelTypeSelector = value => {
    this.setState({
      levelTypeSelector: value
    });
  };

  handleLevelChange = (data) => {
    this.handleLevelTypeSelector(true);
    let selectedLevels = [];
    if (data === "Select All" || data === "Unselect All") {
      let newLevelData = this.state.levelData.map((level) => {
        let subLevels =
          level.levels.length > 0 &&
          level.levels.map((subLevel) => {
            selectedLevels = selectedLevels.concat(level.name + ":" + subLevel.name);
            return { ...subLevel, selected: !this.state.levelData[0].selected };
          });
        if (level.name === "Select All" || level.name === "Unselect All") {
          let name =
            level.name === "Select All" ? "Unselect All" : "Select All";
          return { ...level, name: name, selected: !level.selected };
        }
        return {
          ...level,
          selected: !this.state.levelData[0].selected,
          levels: subLevels,
        };
      });
      if (data === "Unselect All") selectedLevels = [];
      this.setState({
        levelData: newLevelData,
        selectedLevels: selectedLevels,
      });
    } else {
      let newLevelData = this.state.levelData.map((level) => {
        if (level.name === data) return { ...level, clicked: !level.clicked };
        return { ...level, clicked: false };
      });
      this.setState({
        levelData: newLevelData,
        news_info: {
          ...this.state.news_info,
          level: data,
        },
      });
    }
  };

  handleSpecLevelChange = (evt, selectedLevel) => {
    evt.preventDefault();
    evt.stopPropagation();
    let selectedLevels = this.state.selectedLevels;
    let newLevelData = this.state.levelData.map((level) => {
      if (level.name === selectedLevel.name) {
        let subLevels =
          level.levels.length > 0 &&
          level.levels.map((subLevel) => {
            if (level.selected) {
              if (
                selectedLevels &&
                selectedLevels.some(
                  (data) => data === level.name + ":" + subLevel.name
                )
              )
                selectedLevels = selectedLevels.filter((selectedLevel) => {
                  return selectedLevel !== level.name + ":" + subLevel.name;
                });
            } else {
              if (
                !this.state.selectedLevels.some(
                  (data) => data === level.name + ":" + subLevel.name
                )
              ) {
                selectedLevels = selectedLevels.concat(
                  level.name + ":" + subLevel.name
                );
              }
            }
            return { ...subLevel, selected: !level.selected };
          });

        return { ...level, selected: !level.selected, levels: subLevels };
      }

      return level;
    });

    this.setState({
      levelData: newLevelData,
      selectedLevels: selectedLevels,
    });
  };

  handleDateChange = date => {
    this.setState({
      selectedDate: moment(date).format("YYYY-MM-DD")
    });
  };

  handleSubLevelSelected = (levelName, subLevel) => {
    let newLevelData = this.state.levelData.map((level) => {
      if (level.name === levelName) {
        let val = false;
        let subLevels = level.levels.map((subLevelOption) => {
          if (subLevelOption.name === subLevel.name) {
            if (subLevel.selected) {
              let selectedLevels = this.state.selectedLevels.filter(
                (selectedLevel) => {
                  return selectedLevel !== levelName + ":" + subLevel.name;
                }
              );

              this.setState({
                selectedLevels: selectedLevels,
              });
            } else {
              this.setState({
                selectedLevels: this.state.selectedLevels.concat(
                  levelName + ":" + subLevel.name
                ),
              });
            }

            return { ...subLevelOption, selected: !subLevelOption.selected };
          }
          return subLevelOption;
        });
        val = subLevels && (subLevels[0].selected || subLevels[1].selected);
        return { ...level, selected: val, levels: subLevels };
      }
      return { ...level };
    });
    this.setState({
      levelData: newLevelData,
    });
  };

  handleEditBtn = () => {
    this.setState({
      newsEdit: !this.state.newsEdit
    });

    if (!this.state.newsEdit) {
      this.props.newsFreeds.setEnableNewsEdit(true);
    }
  };

  handleErrorCheck = () => {
    let state = this.state;
    let str = "";
    str += state.selectedLevels.length === 0 ? "select levels, " : "";
    str += state.news_info.image === "" ? "select image, " : "";
    str += state.news_info.name === "" ? "enter news fread title" : "";
    if (str !== "") {
      errorHandler("Please " + str);
    }
    return str;
  };

  handleLevelBtn = () => {
    let str = this.handleErrorCheck();
    let newsFreeds = this.props.newsFreeds;
    let gradeLevel = newsFreeds.active_news_grade_level;
    let level = newsFreeds.active_news_level;
    let activeLevel = gradeLevel + ":" + level;
    if (str === "") {
      newsFreeds.setEnableNewsEdit(false);
      if (!this.state.selectedLevels.some(data => data === activeLevel)) {
        swal({
          text: "Are you sure that you want to update news fread ?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          this.handleEditBtn();
          if (result.value) {
            let selectedLevels = this.state.selectedLevels.filter(level => {
              return level !== activeLevel;
            });
            this.props.newsFreeds.requestUpdateNewsFreed({
              ...this.state.news_info,
              grade_level: selectedLevels
            });
            this.props.history.push("/news-freads/" + gradeLevel + "/" + level);
          } else {
            this.setState({
              newsEdit: false
            });
            this.props.newsFreeds.requestUpdateNewsFreed({
              ...this.state.news_info,
              grade_level: this.state.selectedLevels
            });
          }
        });
      } else {
        newsFreeds.requestUpdateNewsFreed({
          ...this.state.news_info,
          grade_level: this.state.selectedLevels,
          date: moment(this.state.selectedDate).format("YYYY-MM-DD")
        });
        this.handleEditBtn();
      }
    }
  };

  handleCreateBtn = () => {
    let str = this.handleErrorCheck();
    let newsFreeds = this.props.newsFreeds;

    if (str === "") {
      if (newsFreeds.questions && newsFreeds.questions.length > 0) {
        newsFreeds.setEnableNewsEdit(false);
        let selectedDate = new Date(this.state.selectedDate);
        let month =
          selectedDate.getMonth() >= 9
            ? selectedDate.getMonth() + 1
            : "0" + (selectedDate.getMonth() + 1);
        let day =
          selectedDate.getDate() < 10
            ? "0" + selectedDate.getDate()
            : selectedDate.getDate();
        let dateData = selectedDate.getFullYear() + "-" + month + "-" + day;
        let activeLevel = newsFreeds.active_news_grade_level;
        let activeSubLevel = newsFreeds.active_news_level;

        newsFreeds.requestCreateNewsFreed({
          ...this.state.news_info,
          date: dateData,
          grade_level: this.state.selectedLevels
        });
        this.props.history.push(
          "/news-freads/" + activeLevel + "/" + activeSubLevel
        );
      } else {
        errorHandler("PLease create mcq to create news fread");
      }
    }
  };

  handleSubLevelSelector = subLevel => { };

  handleSelectedLevels = (data) => {
    this.handleLevelTypeSelector(!this.state.levelTypeSelector);
    let newsFreeds = this.props.newsFreeds;
    if (newsFreeds.active_news_freed) {
      let newsLevels = [];
      if (data === "Select All" || data === "Unselect All") {
        let newLevelData = this.state.levelData.map((level) => {
          let subLevels =
            level.levels.length > 0 &&
            level.levels.map((subLevel) => {
              newsLevels = newsLevels.concat(level.name + ":" + subLevel.name);
              return { ...subLevel, selected: !this.state.levelData[0].selected };
            });
          if (level.name === "Select All" || level.name === "Unselect All") {
            let name =
              level.name === "Select All" ? "Unselect All" : "Select All";
            return { ...level, name: name, selected: !level.selected };
          }
          return {
            ...level,
            selected: !this.state.levelData[0].selected,
            levels: subLevels,
          };
        });
        if (data === "Unselect All") newsLevels = [];
        this.setState({
          levelData: newLevelData,
          selectedLevels: newsLevels,
        });
      } else {
        let newLevelData = this.state.levelData.map((level) => {
          if (level.name === data) return { ...level, clicked: !level.clicked };
          return { ...level, clicked: false };
        });
        this.setState({
          levelData: newLevelData,
          news_info: {
            ...this.state.news_info,
            level: data,
          },
        });
      }
    }
  }

  render() {
    let state = this.state;
    let newsFreeds = this.props.newsFreeds;
    let currentPath = window.location.href;
    const permission = this.props.onboard.permission;

    return (
      <NewsFreedsInfoContainer>
        <NewsFreedsDescriptionInfoContainer
          height={this.state.newsEdit ? "200px" : "160px"}
        >
          {this.state.news_info.image === "" ? (
            <ActivityUploadImageContainer width="180px">
              <ActivityUploadImageButton type="button">
                <img
                  src={require("static/img/cloud-upload-icon.png")}
                  alt="Upload"
                />
                <span>Upload Image </span>
              </ActivityUploadImageButton>

              <SelectFileIn
                type="file"
                onChange={(e) => this.handleImageChange(e)}
              />
            </ActivityUploadImageContainer>
          ) : this.state.enableLoad ? (
            <ActivityUploadImageContainer width="180px">
              <ImageLoader>
                {" "}
                <img
                  alt="loading"
                  width="30"
                  height="30"
                  src="http://photokonkurs.russia.travel/images/icons/preloader.gif"
                />
              </ImageLoader>
            </ActivityUploadImageContainer>
          ) : (
            <ActivityUploadImageContainer
              width="180px"
              onMouseOver={() => this.handleImageFocus("over")}
              onMouseOut={() => this.handleImageFocus("out")}
            >
              <ImageContainer src={this.state.news_info.image} />
              {state.newsEdit ? (
                <ChangeImageButton
                  top={this.state.imageChange ? "84%" : "100%"}
                  opacity={this.state.imageChange ? 1 : 0}
                >
                  Change Image
                </ChangeImageButton>
              ) : null}
              {state.newsEdit ? (
                <SelectFileIn
                  type="file"
                  onChange={(e) => this.handleImageChange(e)}
                />
              ) : null}
            </ActivityUploadImageContainer>
          )}
          <ActivityDescription height="auto">
            {!state.newsEdit ? (
              <StorySectionLabelsContainer>
                <NewsDescriptionLabel>
                  <span>
                    {this.state.selectedLevels.length + " "} Levels Selected |{" "}
                    {this.props.newsFreeds.active_news_grade_level}(
                    {this.props.newsFreeds.active_news_level})
                  </span>
                  <span> Source: {this.state.news_info.source}</span>
                  {Permission.getPermission(permission, "change_newsfread") && (
                    <img
                      src={require("static/img/editicon.png")}
                      alt="edit icon"
                      className="image-fluid"
                      style={{ position: "absolute", top: 0, left: "220px" }}
                      onClick={this.handleEditBtn}
                    />
                  )}
                </NewsDescriptionLabel>
              </StorySectionLabelsContainer>
            ) : (
              <StorySectionLabelsContainer>
                <FlexBetween
                  style={{ width: "80%", justifyContent: "flex-start" }}
                >
                  <DropDown
                    minWidth="160px"
                    active={this.state.levelTypeSelector}
                    onBlur={() => this.handleLevelTypeSelector(false)}
                    tabIndex="1"
                  >
                    <div
                      style={{ fontSize: "14px", height: "24px" }}
                        onClick={() => {
                          if (!this.state.levelTypeSelector) {
                            this.setLevelData();
                          }
                          this.handleLevelTypeSelector(!this.state.levelTypeSelector);
                        }}
                    >
                      {this.state.selectedLevels.length >= 25
                        ? "All "
                        : this.state.selectedLevels.length + " "}{" "}
                      Levels Selected
                      <Chevron>
                        <img
                          src={require("static/img/downarrowicon.png")}
                          alt="down-arrow"
                        />
                      </Chevron>
                    </div>
                    <DropDownMenu
                      maxHeight="150px"
                      active={this.state.levelTypeSelector}
                      color="#fff"
                      style={{ padding: "0px" }}
                    >
                      {this.state.levelData.map((levelData, index) => (
                        <DropdownItem key={index}>
                          <FlexStart
                            style={{
                              width: "100%",
                              padding: "6px 8px",
                              position: "relative",
                              borderBottom: "solid 1px #e6e6e6",
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={() => this.handleLevelChange(levelData.name)}
                          >
                            <CheckBall
                              onClick={(evt) =>
                                levelData.name === "Select All" ||
                                levelData.name === "Unselect All"
                                  ? this.handleLevelChange(levelData.name)
                                  : this.handleSpecLevelChange(evt, levelData)
                              }
                              style={{ marginRight: "6px" }}
                              active={levelData.selected || levelData.clicked}
                            >
                              <CheckBallInner
                                active={levelData.selected || levelData.clicked}
                              />
                            </CheckBall>
                            {levelData.levels.length > 0 && (
                              <Chevron
                                cross={
                                  levelData.clicked
                                    ? "rotate(0deg)"
                                    : "rotate(-90deg)"
                                }
                              >
                                <img
                                  src={require("static/img/downarrowicon.png")}
                                  alt="down-arrow"
                                />
                              </Chevron>
                            )}

                            {levelData.name}
                          </FlexStart>
                          {levelData.clicked &&
                            levelData.levels.length > 0 &&
                            levelData.levels.map((subLevel, i) => (
                              <SubLevelItem
                                key={i}
                                style={{
                                  backgroundColor: "#faf7ff",
                                  width: "100%",
                                  padding: "6px 8px 6px 32px",
                                  justifyContent: "flex-start",
                                  borderBottom: "solid 1px #e6e6e6",
                                }}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                  this.handleSubLevelSelected(
                                    levelData.name,
                                    subLevel
                                  );
                                }}
                              >
                                <CheckBall
                                  style={{ marginRight: "6px" }}
                                  active={subLevel.selected}
                                >
                                  <CheckBallInner active={subLevel.selected} />
                                </CheckBall>{" "}
                                {subLevel.name}
                              </SubLevelItem>
                            ))}
                        </DropdownItem>
                      ))}
                    </DropDownMenu>
                  </DropDown>

                  <StoryInputField
                    height="32px"
                    primary
                    placeholder="Source"
                    border={
                      !state.newsEdit ? "none" : "solid 1px rgba(40,50,112,0.1)"
                    }
                    style={{ marginLeft: "14px" }}
                    fontSize={this.state.newsEdit ? "14px" : "18px"}
                    id="activityPackName"
                    value={state.news_info.source}
                    width="50%"
                    left={state.newsEdit ? "6px" : "0px"}
                    margin={state.newsEdit ? "4px 0px " : "0px"}
                    onChange={this.handleSourceChange}
                    disabled={!this.state.newsEdit}
                  />
                </FlexBetween>

                {!currentPath.includes("/create") ? (
                  <ThemeButton
                    primary
                    onClick={this.handleLevelBtn}
                    style={{ width: "200px" }}
                  >
                    Save Changes
                  </ThemeButton>
                ) : (
                  <ThemeButton
                    primary
                    onClick={this.handleCreateBtn}
                    style={{ width: "200px" }}
                  >
                    Create News Fread
                  </ThemeButton>
                )}
              </StorySectionLabelsContainer>
            )}

            <div id="news-freeds-date">
              <DateSelectionField
                style={{
                  overflow: "hidden",
                  width: "160px",
                  margin: "10px 0px",
                }}
              >
                <img
                  src={require("static/img/date-icon.png")}
                  alt="startDate"
                />
                <DatePicker
                  style={{ width: "100%" }}
                  selected={
                    moment.isMoment(this.state.selectedDate)
                      ? this.state.selectedDate.toDate()
                      : this.state.selectedDate
                  }
                  onChange={this.handleDateChange}
                  disabled={!this.state.newsEdit || this.state.disabled}
                  minDate={new Date()}
                />
              </DateSelectionField>
            </div>
            <StoryInputField
              height="40px"
              primary
              placeholder="Add New Fread Title "
              border={
                !state.newsEdit ? "none" : "solid 1px rgba(40,50,112,0.1)"
              }
              fontSize={this.state.newsEdit ? "14px" : "16px"}
              value={state.news_info.name}
              width={state.newsEdit ? "75%" : "100%"}
              left={state.newsEdit ? "6px" : "0px"}
              margin={state.newsEdit ? "4px 0px " : "0px"}
              onChange={this.handleNameChange}
              disabled={!this.state.newsEdit}
            />
          </ActivityDescription>
          {!this.state.newsEdit && newsFreeds.active_news_freed && (
            <ModalCountOverlayContainer>
              <ModalCountItem>
                <span> {newsFreeds.active_news_freed.reading_count}</span>
                <i className="fa fa-sticky-note-o" />
              </ModalCountItem>
              <ModalCountItem>
                <span> {newsFreeds.active_news_freed.completed_count} </span>
                <i className="fa fa-bullseye" />
              </ModalCountItem>
              <ModalCountItem>
                <span>{newsFreeds.active_news_freed.accuracy} </span>
                <i className="fa fa-tachometer" />
              </ModalCountItem>
            </ModalCountOverlayContainer>
          )}
        </NewsFreedsDescriptionInfoContainer>
      </NewsFreedsInfoContainer>
    );
  }
}
export default connectStore({
  newsFreeds,
  level,
  onboard
})(NewsFreedsInfo);